export default __webpack_public_path__ + "static/media/img_tutor_howitworks_04@medium.bf8cab98.png";